import { render, staticRenderFns } from "./dbSavedFileHistory.vue?vue&type=template&id=25733516"
import script from "./dbSavedFileHistory.vue?vue&type=script&lang=js"
export * from "./dbSavedFileHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25733516')) {
      api.createRecord('25733516', component.options)
    } else {
      api.reload('25733516', component.options)
    }
    module.hot.accept("./dbSavedFileHistory.vue?vue&type=template&id=25733516", function () {
      api.rerender('25733516', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/billing/shippingCharges/components/dbSavedFileHistory.vue"
export default component.exports